/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Hypervisor';
export const filterTitle = t`Hypervisor`;
export const entityType = ENTITY_TYPES.HYPERVISOR;

export function useHypervisor() {
    return useEntity(filterId);
}

export function useHypervisorName() {
    return useEntityName(filterId);
}

const columns = [
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: 'IP Address',
        width: 150,
        flex: 1,
        sortable: true,
        mapping: 'ipAddress',
    },
];

const dataSourceParams = {
    entityFields: ['name', 'ipAddress'],
};

function HypervisorFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

HypervisorFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

HypervisorFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/vmware-host-detail',
                tooltipTemplate: t`View details for <%= name %>`,
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(HypervisorFilter);
